<template>
  <div class="user-account-manager">
    <h1>User Accounts</h1>
    <p v-if="statusMessage" :class="['status', statusType]">{{ statusMessage }}</p>
<div class="referral-lookup">
  <input v-model="referralSearch" placeholder="Enter referral code" />
<button :disabled="!referralSearch.trim()" @click="lookupReferralCode">Lookup Referral Code</button>

  <p v-if="referralOwnerResult">
    Owner: <strong>{{ referralOwnerResult }}</strong>
  </p>
  <p v-else-if="referralOwnerResult === '' && referralSearched">
    ❌ Not found.
  </p>
</div>

    <table v-if="users.length">
      <thead>
        <tr>
          <th>Username</th>
          <th>Credits</th>
          <th>LinkCheck</th>
          <th>Subscription</th>
          <th>Unlimited?</th>
          <th>Expires</th>
          <th>Actions</th>
         <th>User’s Referral</th>
    <th>Used Referral</th>  <!-- NEW -->
    <th>Promo</th>          <!-- NEW -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.username">
          <td>{{ user.username }}</td>
          <td>{{ user.credit_balance }}</td>
          <td>{{ user.linkcheck_credit_balance ?? 0 }}</td>

          <td>{{ user.is_subscription_user ? '✅' : '❌' }}</td>
          <td>{{ user.is_unlimited_user ? '✅' : '❌' }}</td>

          <td>{{ user.subscription_expires_at ? formatTime(user.subscription_expires_at) : '—' }}</td>
          <td>
            <button @click="viewPayments(user.username)">View History</button>
            <button @click="setSelectedUser(user.username)">Manage</button>
            <button @click="toggleUnlimited(user.username, user.is_unlimited_user)">
  {{ user.is_unlimited_user ? 'Remove Unlimited' : 'Give Unlimited' }}
</button>

          </td>
         <!-- Existing: computed referral to share out -->
    <td><code>{{ referralCodeForUser(user.username) }}</code></td>

    <!-- NEW: code the user entered at signup -->
    <td>
      <a v-if="user.used_referral_code"
         href="#"
         @click.prevent="filterByUsedReferral(user.used_referral_code)">
        {{ user.used_referral_code }}
      </a>
      <span v-else>—</span>
    </td>

    <!-- NEW: promo the user entered at signup -->
    <td>
      <span v-if="user.promo_code" class="badge badge--promo"
            @click="filterByPromo(user.promo_code)"
            style="cursor: pointer;">
        {{ user.promo_code }}
      </span>
      <span v-else>—</span>
    </td>

        </tr>
      </tbody>
    </table>

    <div v-if="total > limit" class="pagination">
      <button @click="prevPage" :disabled="page === 1">Prev</button>
      Page {{ page }} of {{ Math.ceil(total / limit) }}
      <button @click="nextPage" :disabled="page * limit >= total">Next</button>
    </div>

    <p v-if="!users.length && total === 0">No users found.</p>
<div class="referral-lookup">
  <input v-model="referralSearch" placeholder="Enter referral code" />
  <button :disabled="!referralSearch.trim()" @click="lookupReferralCode">Lookup Referral Code</button>

  <input v-model="promoSearch" placeholder="Filter by promo code" style="margin-left:10px;" />
  <button :disabled="!promoSearch.trim()" @click="filterByPromo(promoSearch)">Filter Promo</button>

  <button v-if="promoSearch || usedRefFilter || promoFilter" @click="clearFilters" style="margin-left:6px;">Clear Filters</button>

  <p v-if="referralOwnerResult">
    Owner: <strong>{{ referralOwnerResult }}</strong>
  </p>
  <p v-else-if="referralOwnerResult === '' && referralSearched">
    ❌ Not found.
  </p>
</div>

    <div v-if="selectedUser">
      <h2>Manage {{ selectedUser }}</h2>

      <div class="management-section">
        <label>
          Add Credits (max 500):
          <input type="number" v-model.number="creditAmount" min="0" max="500" />
        </label>
        <button @click="submitAddCredits">Add</button>
 <!-- NEW: LinkCheck -->
  <label style="margin-top:10px; display:block;">
    Add LinkCheck Credits (max 50):
    <input type="number" v-model.number="lcCreditAmount" min="0" max="50" />
  </label>
  <button @click="submitAddLCCredits">Add LinkCheck</button>
        <button @click="addSubscription">+30 Days Subscription</button>

 <div class="scrub-controls">
  <button v-if="!confirmScrubPending" @click="confirmScrubPending = true">
    Scrub Subscription
  </button>

  <template v-else>
    <span class="confirm-label">Confirm scrub?</span>
    <button @click="scrubSubscription" class="confirm-btn">Yes</button>
    <button @click="confirmScrubPending = false" class="cancel-btn">Cancel</button>
  </template>
</div>

      </div>

      <h2>Payment History</h2>
      <table v-if="paymentHistory.length">
        <thead>
          <tr>
            <th>Time</th>
            <th>Amount</th>
            <th>Type</th>
            <th>Status</th>
            <th>ID</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paymentHistory" :key="item.payment_id">
            <td>{{ formatTime(item.created_at) }}</td>
            <td>{{ item.amount_added }}</td>
            <td>{{ item.payment_type }}</td>
            <td>{{ item.payment_status }}</td>
            <td>{{ item.payment_id }}</td>
          </tr>
        </tbody>
      </table>
      <p v-else>No payment history found.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'UserAccountManager',
  data() {
    return {
      users: [],
      page: 1,
      limit: 25,
      total: 0,
      statusMessage: '',
      statusType: '',
      selectedUser: '',
      paymentHistory: [],
      creditAmount: 0,
    lcCreditAmount: 0, // NEW
      confirmScrubPending: false,
  referralSearch: '',
    referralOwnerResult: null,
    referralSearched: false,
    // NEW:
    promoSearch: '',
    usedRefFilter: '',
    promoFilter: '',
    };
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    submitAddLCCredits() {
  if (!this.selectedUser || this.lcCreditAmount <= 0 || this.lcCreditAmount > 50) {
    this.statusMessage = 'Enter a valid LinkCheck credit amount (1–50).';
    this.statusType = 'error';
    return;
  }
  axios.post('/linkcheck/manual_add_credits.php', {
    username: this.selectedUser,
    amount: this.lcCreditAmount
  }, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  })
  .then(res => {
    if (res.data.status === 'success') {
      this.statusMessage = `✅ ${this.lcCreditAmount} LinkCheck credits added to ${this.selectedUser}.`;
      this.statusType = 'success';
      this.lcCreditAmount = 0;
      this.fetchUsers();
      this.viewPayments(this.selectedUser);
    } else {
      this.statusMessage = res.data.message || 'Failed to add LinkCheck credits.';
      this.statusType = 'error';
    }
  })
  .catch(() => {
    this.statusMessage = 'Failed to add LinkCheck credits.';
    this.statusType = 'error';
  });
},

  lookupReferralCode() {
  const trimmed = this.referralSearch.trim();


  if (!trimmed) {
    this.referralOwnerResult = null;
    this.referralSearched = false;
    this.statusMessage = 'Please enter a referral code.';
    this.statusType = 'error';
    return;
  }

  this.statusMessage = '';
  this.statusType = '';
  this.referralOwnerResult = null;
  this.referralSearched = true;

  axios.post('/etherscan/lookup_user_by_referral.php', {
    referral_code: trimmed
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then(res => {
    if (res.data.status === 'success') {
      this.referralOwnerResult = res.data.username;
    } else {
      this.referralOwnerResult = '';
    }
  })
  .catch(() => {
    this.statusMessage = 'Referral lookup failed.';
    this.statusType = 'error';
  });
}
,
    referralCodeForUser(username) {
  return `R25${this.simpleHash(username.toLowerCase())}`;
},
simpleHash(input) {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}
,
    fetchUsers() {
    // Include filters if present
    const params = new URLSearchParams({
      page: this.page,
      limit: this.limit
    });
    if (this.usedRefFilter) params.set('used_ref', this.usedRefFilter);
    if (this.promoFilter)   params.set('promo', this.promoFilter);

    axios.get(`/etherscan/fetch_user_accounts.php?${params.toString()}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    .then(res => {
      if (res.data.status === 'success') {
        this.users = res.data.users;
        this.total = res.data.total;
      } else {
        this.statusMessage = res.data.message;
        this.statusType = 'error';
      }
    })
    .catch(() => {
      this.statusMessage = 'Failed to load user list.';
      this.statusType = 'error';
    });
  },

  filterByUsedReferral(code) {
    this.usedRefFilter = (code || '').trim();
    this.promoFilter = '';
    this.page = 1;
    this.fetchUsers();
    this.statusMessage = this.usedRefFilter ? `Filtered by used referral: ${this.usedRefFilter}` : '';
    this.statusType = this.usedRefFilter ? 'success' : '';
  },

  filterByPromo(code) {
    this.promoFilter = (code || '').trim();
    this.usedRefFilter = '';
    this.page = 1;
    this.fetchUsers();
    this.statusMessage = this.promoFilter ? `Filtered by promo: ${this.promoFilter}` : '';
    this.statusType = this.promoFilter ? 'success' : '';
  },

  clearFilters() {
    this.promoSearch = '';
    this.usedRefFilter = '';
    this.promoFilter = '';
    this.page = 1;
    this.fetchUsers();
    this.statusMessage = '';
    this.statusType = '';
  },
    scrubSubscription() {
if (!this.selectedUser) return;
this.confirmScrubPending = false;

  const confirmed = confirm(`Are you sure you want to scrub all subscription data for ${this.selectedUser}?`);
  if (!confirmed) return;

  axios.post('/etherscan/scrub_subscription.php', {
    username: this.selectedUser
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then(res => {
    if (res.data.status === 'success') {
      this.statusMessage = `🧹 Subscription scrubbed for ${this.selectedUser}.`;
      this.statusType = 'success';
      this.fetchUsers();
      this.viewPayments(this.selectedUser);
    } else {
      this.statusMessage = res.data.message;
      this.statusType = 'error';
    }
  })
  .catch(() => {
    this.statusMessage = 'Failed to scrub subscription.';
    this.statusType = 'error';
  });
},

    nextPage() {
      if (this.page * this.limit < this.total) {
        this.page++;
        this.fetchUsers();
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.fetchUsers();
      }
    },
    formatTime(iso) {
      return new Date(iso).toLocaleString();
    },
    viewPayments(username) {
      this.selectedUser = username;
      this.paymentHistory = [];
      axios.post('/etherscan/fetch_user_payment_history.php', {
        username: username
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(res => {
        if (res.data.status === 'success') {
          this.paymentHistory = res.data.history;
        } else {
          this.statusMessage = res.data.message;
          this.statusType = 'error';
        }
      })
      .catch(err => {
        console.error('Payment history fetch error:', err);
        this.statusMessage = 'Error retrieving payment history.';
        this.statusType = 'error';
      });
    },
    setSelectedUser(username) {
      this.selectedUser = username;
      this.creditAmount = 0;
      this.viewPayments(username);
    },
    submitAddCredits() {
      if (!this.selectedUser || this.creditAmount <= 0 || this.creditAmount > 500) {
        this.statusMessage = 'Enter a valid credit amount (1–500).';
        this.statusType = 'error';
        return;
      }
      axios.post('/etherscan/manual_add_credits.php', {
        username: this.selectedUser,
        amount: this.creditAmount
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(res => {
        if (res.data.status === 'success') {
          this.statusMessage = `✅ ${this.creditAmount} credits added to ${this.selectedUser}.`;
          this.statusType = 'success';
          this.creditAmount = 0;
          this.fetchUsers();
          this.viewPayments(this.selectedUser);
        } else {
          this.statusMessage = res.data.message;
          this.statusType = 'error';
        }
      })
      .catch(() => {
        this.statusMessage = 'Failed to add credits.';
        this.statusType = 'error';
      });
    },
    toggleUnlimited(username, currentStatus) {
  const newStatus = !currentStatus;

  axios.post('/etherscan/toggle_unlimited_access.php', {
    username: username,
    enable: newStatus
  }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
  .then(res => {
    if (res.data.status === 'success') {
      this.statusMessage = res.data.message;
      this.statusType = 'success';
      this.fetchUsers(); // Refresh the table
      if (this.selectedUser === username) {
        this.viewPayments(username); // Optional: if you want to refresh the selected view
      }
    } else {
      this.statusMessage = res.data.message || 'Failed to toggle access.';
      this.statusType = 'error';
    }
  })
  .catch(err => {
    console.error('Error toggling unlimited access:', err);
    this.statusMessage = 'Error updating unlimited status.';
    this.statusType = 'error';
  });
}
,
    addSubscription() {
      if (!this.selectedUser) return;
      axios.post('/etherscan/manual_add_subscription.php', {
        username: this.selectedUser
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(res => {
        if (res.data.status === 'success') {
          this.statusMessage = `✅ 30-day subscription added to ${this.selectedUser}.`;
          this.statusType = 'success';
          this.fetchUsers();
          this.viewPayments(this.selectedUser);
        } else {
          this.statusMessage = res.data.message;
          this.statusType = 'error';
        }
      })
      .catch(() => {
        this.statusMessage = 'Failed to add subscription.';
        this.statusType = 'error';
      });
    }
  }
};
</script>

<style scoped>
.user-account-manager {
  max-width: 1100px;
  margin: 0 auto;
}
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: 10px;
}
th, td {
  border: 1px solid #ccc;
  padding: 6px;
}
button {
  padding: 5px 8px;
  font-size: 12px;
  margin-right: 4px;
}
.status.success {
  color: green;
}
.status.error {
  color: red;
}
.pagination {
  margin-top: 12px;
  text-align: center;
}
.pagination button {
  margin: 0 10px;
}
.management-section {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ddd;
  background: #f9f9f9;
  border-radius: 4px;
  max-width: 400px;
}
.management-section label {
  display: block;
  margin-bottom: 6px;
}
.management-section input {
  width: 100%;
  margin-bottom: 8px;
  padding: 6px;
  font-size: 13px;
}.scrub-controls {
  margin-top: 12px;
}
.confirm-label {
  margin-right: 6px;
  font-weight: bold;
  color: #cc0000;
}
.confirm-btn {
  background: #d9534f;
  color: white;
}
.cancel-btn {
  background: #eee;
  color: #333;
}
.confirm-btn, .cancel-btn {
  padding: 5px 10px;
  margin-right: 6px;
  border: none;
  cursor: pointer;
}
.confirm-btn:hover {
  background: #c9302c;
}
.cancel-btn:hover {
  background: #ccc;
}
.referral-lookup {
  margin: 20px 0;
}
.referral-lookup input {
  padding: 6px;
  font-size: 13px;
  width: 250px;
}
.referral-lookup button {
  margin-left: 6px;
  padding: 6px 10px;
}.badge {
  display:inline-block;
  padding:2px 6px;
  border-radius:4px;
  font-size:12px;
  line-height:1;
  border:1px solid #ccc;
}
.badge--promo {
  background:#e6f7ff;
  border-color:#91d5ff;
  color:#096dd9;
}


</style>
